import FeefoAdapter from 'root-packages/feefo/feefoAdapter.js'

export default ({disabled, forcedCount, forcedMerchantRating, forcedRating} = {}) =>
  (class FakeFeefoAdapter extends FeefoAdapter {
    constructor ({feefoMerchantidentifier, feefoUrl}) {
      super({feefoMerchantidentifier, feefoUrl})
      this.disabled = disabled || false
      this.forcedCount = forcedCount
      this.forcedMerchantRating = forcedMerchantRating
      this.forcedRating = forcedRating
    }
    async getParentTourCode (tourCode) {
      if (disabled) return
      return `parent-${tourCode}`
    }

    async getProductRating (tourCode) {
      if (disabled) return
      return {
        merchant: {
          identifier: this.feefoMerchantidentifier,
          url: `http://www.${this.feefoMerchantidentifier}.com`,
          logo: `${this.feefoMerchantidentifier}.png`,
          review_url: `https://www.feefo.com/en-GB/reviews/${this.feefoMerchantidentifier}`,
        },
        meta: {count: this.forcedCount || 289},
        rating: {
          min: 1.0,
          max: 5.0,
          rating: this.forcedRating || 4.8,
        },
        product: {
          title: "Tour Name",
          sku:[tourCode],
          reviews_url: `https://www.feefo.com/en-GB/reviews/${this.feefoMerchantidentifier}/products/tour-name?sku=${tourCode}`,
        },
      }
    }

    async getParentRating (tourParentCode) {
      if (disabled) return
      return await this.getProductRating(tourParentCode)
    }

    async getMerchantRating () {
      if (disabled) return
      return {
        merchant: this.merchantData(),
        rating: {
          min: 1.0,
          max: 5.0,
          rating: this.forcedMerchantRating || 4.6,
        },
      }
    }

    merchantData () {
      return {
        identifier: this.feefoMerchantidentifier,
        url: `http://www.${this.feefoMerchantidentifier}.com`,
        logo: `${this.feefoMerchantidentifier}.png`,
        review_url: `https://www.feefo.com/en-GB/reviews/${this.feefoMerchantidentifier}`,
      }
    }
  })

